import { render, staticRenderFns } from "./Nespresso.vue?vue&type=template&id=11230c8a&scoped=true&"
import script from "./Nespresso.vue?vue&type=script&lang=js&"
export * from "./Nespresso.vue?vue&type=script&lang=js&"
import style0 from "./Nespresso.vue?vue&type=style&index=0&id=11230c8a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11230c8a",
  null
  
)

export default component.exports